// Twilio JS fills `call.customParameters` only for OUTGOING calls, from the params passed to
// `device.connect({ params })`. For INCOMING calls the backend's <Parameter> values arrive
// flattened into `call.parameters.Params` as a URL-encoded query string
// (e.g. "isVoice=true&callSid=CA7c40...&customCallerId=acc_381635..."), so reading
// `customParameters` alone silently returns undefined.
export const getCallParam = (call, name) => {
  const fromCustomParams = call?.customParameters?.get?.(name)
  if (fromCustomParams) return fromCustomParams

  const params = call?.parameters?.Params
  if (!params) return undefined
  try {
    return new URLSearchParams(params).get(name) || undefined
  } catch (err) {
    console.warn('Cannot parse Twilio call Params', err)
    return undefined
  }
}
